package kz.dentalcrm.app.navigation

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

@Composable
fun LimitedContent(
    content: @Composable () -> Unit
) {
    Box(modifier = Modifier.widthIn(max = 650.dp), contentAlignment = Alignment.TopCenter) {
        content()
    }
}